import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin } from 'antd';
import { formItemLayout, unexpectedError, tailFormItemLayout, handleBackendFormErrors, backButton } from '../../common_functions';

const Authenticity = props => {
  const { section, id } = useParams();
  const [Authenticity, setAuthenticity] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef('');
  useEffect(() => {
    async function fetchData() {
      try {
        if (id !== 'new') {
          setLoading(true);
          let { data } = await props.getItem('authenticity_confidence', id);
          setAuthenticity(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        console.error(error);
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...Authenticity, ...values };
      const response = await props.saveItem('authenticity_confidence', newState);
      if (response) {
        notification['success']({
          message: !!id ? 'Authenticity confidence updated successfully!' : 'Authenticity confidence saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/authenticity`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col className="app-breadcrumb-col">
            <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/authenticity" }, { title: "Authenticity Confidence", href: "/settings/authenticity" }, { title: id !== 'new' ? `Edit Authenticity Confidence ` : 'Add Authenticity Confidence' }]} />
          </Col>
          <Col className="white-paper">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={12}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {id !== 'new' ? `Edit Authenticity Confidence: ${id}` : 'Add Authenticity Confidence'}
                </Typography.Title>
              </Col>
              <Col xs={12} justify="end"></Col>
            </Row>
            <hr />
            <div className="artist">
              <Form
                ref={formRef}
                layout="vertical"
                {...formItemLayout}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ layout: tailFormItemLayout }}
              >
                {id ? (
                  <Row gutter={24}>
                    {' '}
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="id" label="ID(System Generated)">
                        <Input placeholder={id} disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}

                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="confidence"
                      label="Authenticity Confidence"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Authenticity Confidence is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter authenticity confidence" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="value"
                      label="Value"
                      rules={[
                        {
                          required: true,
                          message: 'Value is required!',
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: 'Please enter a valid number',
                        },
                      ]}
                    >
                      <Input placeholder="Enter value" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item name="desc" label="Authenticity Confidence Description">
                      <Input.TextArea rows={4} placeholder="Enter authenticity confidence description..." />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item {...tailFormItemLayout}>
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={() => backButton(props, '/settings/authenticity')}
                    style={{
                      borderColor: '#d9d9d9',
                      background: '#f5f5f5',
                      color: 'rgba(0, 0, 0, 0.85)',
                    }}
                  >
                    Back
                  </Button>
                  {props.showButton(props.roleType, props.tabs_permissions.settings_authenticity, !!Authenticity ? Authenticity.id : '')}
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default Authenticity;
